import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const AdminColumnField = iotsUtils.fromList(constants.principal.search.adminColumnFields);

export const ColumnField = iotsUtils.fromList(constants.principal.search.columnFields);
